import React from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import { Iata } from 'types/Search/airport';

import { topAirports } from '../../__config/Airports';
import styles from '../Airport.module.scss';

import Airport from './Airport';

interface RecommendationProps {
    entries: Iata[];
    onClick(entry: Iata): void;
}

const Recommendation = ({ entries, onClick }: RecommendationProps) => {
    const { t } = useTranslation();
    const hasRecommendation = !!entries.length;
    return (
        <>
            <div className={styles.Header}>
                {hasRecommendation
                    ? t('TRANS-suggestion[i]', {
                          postProcess: 'interval',
                          count: 2,
                      })
                    : t('TRANS-most-popular-airports')}
            </div>
            <div
                className={classNames(styles.ResultList, styles.Recommendation)}
            >
                <Airport
                    list={hasRecommendation ? entries : topAirports}
                    onChange={onClick}
                    idPrefix={'recommendation-'}
                />
            </div>
        </>
    );
};

export default Recommendation;
